import InteractionContext from '@atlassian/react-ufo/interaction-context';

export type {
	CustomData,
	CustomTiming,
	Label,
	SegmentLabel,
	LabelStack,
	UFOInteractionContextType,
} from '@atlassian/react-ufo/interaction-context';
export { useInteractionContext } from '@atlassian/react-ufo/interaction-context';
export default InteractionContext;
